var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"wrap":""}},[_c('v-layout',[_c('formStepper',{attrs:{"model":_vm.model,"field":_vm.field,"onSave":_vm.updateItem,"context":_vm.currentContext},on:{"onClose":function($event){return _vm.$emit("close")}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }